// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

export const CELL_FONT_SIZE = 12;
export const TITLE_FONT_SIZE = 11;

export const ANALYTICS_THEME = {
  page: '#f8fafd',
  white: G.getTheme('colors.white'),
  amber: G.getTheme('colors.orange'),
  blue: G.getTheme('colors.light.blue'),
  avatarBg: G.getTheme('colors.bgBlue'),
  muted: G.getTheme('colors.light.grey'),
  shadow: G.getTheme('shadows.standard'),
  red: G.getTheme('colors.light.mainRed'),
  ink: G.getTheme('colors.dark.mainDark'),
  green: G.getTheme('colors.light.green'),
  soft: G.getTheme('tables.header.bgColor'),
  navyHover: G.getTheme('colors.steelBlue'),
  blueSoft: G.getTheme('colors.bgLightBlue'),
  line: G.getTheme('tables.rows.borderColor'),
  featuredLabel: G.getTheme('colors.poloBlue'),
  filterBorder: G.getTheme('colors.dark.grey'),
  redSoft: G.getTheme('colors.light.lightPink'),
  headerBg: G.getTheme('tables.header.bgColor'),
  greenSoft: G.getTheme('colors.dark.teaGreen'),
  secondaryText: G.getTheme('colors.steelBlue'),
  weekMuted: G.getTheme('colors.light.blueGrey'),
  driverBlue: G.getTheme('colors.dark.darkBlue'),
  avatarText: G.getTheme('colors.dark.darkBlue'),
  featuredShadow: G.getTheme('shadows.standard'),
  cardShadow: G.getTheme('shadows.cardBoxShadow'),
  navy: G.getTheme('colors.light.navbarBackground'),
  amberSoft: G.getTheme('colors.light.warningBackground'),
  featuredSmall: G.getTheme('colors.light.lightBlueGrey'),
  selectedRow: G.getTheme('tables.rows.highlightedBgColor'),
  featuredGradient: `linear-gradient(135deg, ${G.getTheme('colors.light.navbarBackground')}, ${G.getTheme('colors.steelBlue')})`,
};

export const REPORT_ADDITIONAL_TABLE_STYLES = {
  headerWeight: 700,
  borderRadius: '9px',
  headerBg: '#f3f6f9',
  rowHoverBg: '#f8fbff',
  cellPadding: '11px 10px',
  rowBorderColor: '#edf0f4',
  bg: G.getTheme('colors.white'),
  headerLetterSpacing: '0.055em',
  rowBg: G.getTheme('colors.white'),
  borderColor: ANALYTICS_THEME.line,
  headerColor: G.getTheme('tables.header.textColor'),
};

export const rowBgColor = G.getTheme('tables.rows.bgColor');
export const rowTextColor = G.getTheme('tables.rows.textColor');
export const headerBgColor = G.getTheme('tables.header.bgColor');
export const headerTextColor = G.getTheme('tables.header.textColor');
export const rowHoverBgColor = G.getTheme('tables.rows.hoverBgColor');
export const subTitleBgColor = G.getTheme('tables.subTitle.bgColor');
export const toggleIconColor = G.getTheme('tables.rows.toggleIconColor');

export const BORDER = `1px solid ${G.getTheme('tables.rows.borderColor')}`;

// the report's distanceUom as the unit suffix of every mileage/rate column title
export const uomLabelMap = { MILE: 'mi', KM: 'km' };

// backend default when empty = DELIVERED — preselected so the default is visible
export const DEFAULT_STATUSES = [GC.LOAD_STATUS_DELIVERED];

// heights of the sticky rows a drill-down's column header has to stick below
export const HEADER_HEIGHT = 42;
export const COMPACT_HEADER_HEIGHT = 32;
export const MATRIX_ROW_HEIGHT = 56;
export const GRAND_TOTAL_ROW_HEIGHT = 40;
export const SCROLLBAR_SIZE = 8;
export const NO_DATA_ROW_HEIGHT = 60;
export const SUB_TABLE_PADDING = 15;
export const SUB_TABLE_MAX_HEIGHT = 500;
export const COMPACT_MATRIX_ROW_HEIGHT = 42;
export const COMPACT_GRAND_TOTAL_ROW_HEIGHT = 32;

// nested VirtualizedTable row and header heights
export const SUB_TABLE_ROW_HEIGHT = 32;
export const COMPACT_SUB_TABLE_ROW_HEIGHT = 28;
export const SUB_TABLE_TITLE_ROW_HEIGHT = 45;
export const COMPACT_SUB_TABLE_TITLE_ROW_HEIGHT = 32;

// divider on the right edge of a frozen column — same inset seam the shared Table uses
export const FROZEN_COL_SHADOW = '6px 0 12px rgba(24, 36, 58, 0.035)';

// the react-select controls in a report's filter row paint their own border at rgb(200,200,200),
// which no theme token matches — a plain Input standing next to them has to be told this or it
// takes forms.inputs.borderColor and reads two shades darker than every control beside it
export const FILTER_BORDER_COLOR = '#C8C8C8';

// Chip list cap for report multi-selects. Extra values scroll inside the control
// so the filter bar does not grow and squeeze the report.
export const FILTER_VALUE_MAX_HEIGHT = 48;

// left indent of every expanded sub-table
export const SUB_TABLE_INDENT = 40;

export const INITIAL_QUICK_DAYS = 30;

// waypoint page sizes: ReportTable (main matrix) vs nested VirtualizedTable drill-downs
export const TABLE_LIMIT = 30;
export const VIRTUALIZED_TABLE_LIMIT = 70;

// Lane RPM grain; persisted with that page's filters
export const LANE_GRAIN_FULL = 'FULL';

export const PAGE_LANE_RPM = 'laneRpm';
export const PAGE_WEEKLY_RPM = 'weeklyRpm';
export const PAGE_FLEET_ACTIVITY = 'fleetActivity';

// the platform presets plus a full year, added for the reports only — GC.QUICK_DAYS_FILTER itself is
// left alone so master-invoice and payroll keep their four. Derived, so the reports still follow any
// change to the shared list. 365 days sits just inside the server's own cap
// (ReportDateRangeValidator.MAX_RANGE = 1 year) and bounds the week columns at 53.
export const QUICK_DAYS = [...GC.QUICK_DAYS_FILTER, 365];
